import { SupademoIcon } from '../../../assets/icons/supademo';
import { createEmbedProvider } from '../factory';

export const SUPADEMO_REGEX = /^https:\/\/app\.supademo\.com\/embed\/(.+)$/;

export const supademoProvider = createEmbedProvider({
  id: 'supademo',
  label: 'Supademo',
  icon: <SupademoIcon className="size-5" />,
  regex: SUPADEMO_REGEX,
  buildEmbedUrl: (match) => `https://app.supademo.com/embed/${match[1]}`,
});
